'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lio_intela_sites_digitalinternship_data_BlogPosts$Section(heading, paragraphs) {
  this.hW = null;
  this.hX = null;
  this.hW = heading;
  this.hX = paragraphs;
}
export { $c_Lio_intela_sites_digitalinternship_data_BlogPosts$Section as $c_Lio_intela_sites_digitalinternship_data_BlogPosts$Section };
$p = $c_Lio_intela_sites_digitalinternship_data_BlogPosts$Section.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lio_intela_sites_digitalinternship_data_BlogPosts$Section;
/** @constructor */
function $h_Lio_intela_sites_digitalinternship_data_BlogPosts$Section() {
}
export { $h_Lio_intela_sites_digitalinternship_data_BlogPosts$Section as $h_Lio_intela_sites_digitalinternship_data_BlogPosts$Section };
$h_Lio_intela_sites_digitalinternship_data_BlogPosts$Section.prototype = $p;
$p.N = (function() {
  return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Product$$anon$1(this);
});
$p.s = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_util_hashing_MurmurHash3$().W(this, (-162532404), true);
});
$p.i = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lio_intela_sites_digitalinternship_data_BlogPosts$Section)) {
    if ((this.hW === x$0.hW)) {
      var x = this.hX;
      var x$2 = x$0.hX;
      return ((x === null) ? (x$2 === null) : x.i(x$2));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.t = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_ScalaRunTime$().V(this);
});
$p.G = (function() {
  return 2;
});
$p.I = (function() {
  return "Section";
});
$p.H = (function(n) {
  if ((n === 0)) {
    return this.hW;
  }
  if ((n === 1)) {
    return this.hX;
  }
  throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lio_intela_sites_digitalinternship_data_BlogPosts$Section(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.bq)));
}
export { $isArrayOf_Lio_intela_sites_digitalinternship_data_BlogPosts$Section as $isArrayOf_Lio_intela_sites_digitalinternship_data_BlogPosts$Section };
var $d_Lio_intela_sites_digitalinternship_data_BlogPosts$Section = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lio_intela_sites_digitalinternship_data_BlogPosts$Section, "io.intela.sites.digitalinternship.data.BlogPosts$Section", ({
  bq: 1,
  b: 1,
  e: 1,
  a: 1
}));
export { $d_Lio_intela_sites_digitalinternship_data_BlogPosts$Section as $d_Lio_intela_sites_digitalinternship_data_BlogPosts$Section };
//# sourceMappingURL=io.intela.sites.digitalinternship.data.-Blog-Posts$-Section.js.map
